var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("bulma-autocomplete", {
    class: ["phone-no-autocomplete", _vm.classProp],
    attrs: {
      id: "phone-no-autocomplete",
      data: _vm.items,
      field: "phoneNo",
      value: _vm.innerValue,
      "keep-first": true,
      placeholder: "Search name/mobile",
      expanded: true,
    },
    on: { input: _vm.getCustomerInsurerPhoneNo, select: _vm.select },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            props.option.isGroupHeader
              ? _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between is-align-items-center custom-header p-1",
                    class: `has-background-${_vm.$theme.name} has-text-invert`,
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "is-size-8 has-text-weight-bold" },
                      [_vm._v(" " + _vm._s(props.option.groupName) + " ")]
                    ),
                  ]
                )
              : _vm._e(),
            !props.option.isGroupHeader
              ? _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between is-align-items-center",
                  },
                  [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(props.option.phoneNo))]),
                      props.option.fullName
                        ? _c("span", [
                            _vm._v(" - " + _vm._s(props.option.fullName)),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "is-pulled-right" }, [
                      props.option.groupName
                        ? _c(
                            "span",
                            {
                              staticClass: "tag",
                              class: {
                                "is-success":
                                  props.option.groupName === "Customer",
                                "is-info": props.option.groupName === "Insurer",
                              },
                            },
                            [_vm._v(" " + _vm._s(props.option.groupName) + " ")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.innerValue,
      callback: function ($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }